import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW, POSTFormDataNEW } from '@/request/http'

// 综合测评计划分页
export const getEvaluationTableData = p => POSTNEW('/studentv2/evaluation/plan/page', p)

// 综合测评详情分页(学生)
export const getEvaluationDetailTableDataByStudent = p => POSTNEW('/studentv2/evaluation/apply/page/TEACHER', p)

// 综合测评详情分页(学院，年级，班级)
export const getEvaluationTableDataByOperator = p => POSTNEW('/studentv2/evaluation/apply/getCollegePage', p)

// 综合测评详情统计图(学生)
export const getEvaluationDetailStatisticsByStudent = p => POSTNEW('/studentv2/evaluation/apply/getStudentCount', p)

// 综合测评详情统计图（学院，年级）
export const getEvaluationDetailStatisticsByFacultyAndGradeCount = p => POSTNEW('/studentv2/evaluation/apply/getFacultyAndGradeCount', p)

// 学工获取素质拓展申请 
export const getQualityDevelopmentApprove = p => GETNEW('/studentv2/evaluation/project/getAuditShow', p)

// 学工审批素质拓展
export const submitQualityDevelopmentApprove = p => POSTNEW('/studentv2/evaluation/projectAuditRecord/audit', p)

// 素质拓展申请
export const qualityDevelopmentApprove = p => POSTNEW('/studentv2/evaluation/project/save', p)

// 素质拓展管理分页
export const getQualityDevelopmentMangentTableData = p => POSTNEW('/studentv2/evaluation/project/page', p)

// 素质拓展管理删除
export const qualityDevelopmentDelete = p => POSTNEW('/studentv2/evaluation/project/deleteById', p)

// 素质拓展管理详情
export const getQualityDevelopmentMangentDetail = p => POSTNEW('/studentv2/evaluation/project/getById', p)

// 辅导员提交素质拓展获取选项
export const getQualityDevelopmentOptions = p => GETNEW('/studentv2/evaluation/project/getListByParentId', p)

// 获取素质拓展详情
export const getQualityDevelopmentDetail = p => GETNEW('/studentv2/evaluation/apply/getSztz/TEACHER', p)

// 辅导员提交素质拓展
export const submitQualityDevelopment = p => POSTNEW('/studentv2/evaluation/apply/save/TEACHER', p)

// 辅导员提交素质拓展校验
export const submitQualityDevelopmentCheck = p => POSTNEW('/studentv2/evaluation/apply/checkSztz/TEACHER', p)

// 辅导员素质拓展预估得分
export const qualityDevelopmentExpectedScore = p => POSTNEW('/studentv2/evaluation/apply/countScore/TEACHER', p)

// 辅导员素质拓展提交审批
export const qualityDevelopmentSubmitApproval = p => POSTNEW('/studentv2/evaluation/applyDetail/evaluationAudit/TEACHER', p)

// 辅导员设置代理人
export const qualityDevelopmentSetUpAgents = p => POSTNEW('/studentv2/evaluation/proxy/save', p)

// 辅导员删除代理人
export const qualityDevelopmentDeleteAgents = p => POSTNEW('/studentv2/evaluation/proxy/removeById', p)

// 学院素质拓展，停用，启用，撤销按钮
export const qualityDevelopmentDeactivate = p => POSTNEW('/studentv2/evaluation/project/updateProjectStatus', p)

// 获取德育评估详情
export const getMoralEducationEvaluationDetail = p => POSTNEW('/studentv2/evaluation/project/getStudentDYInfo', p)

// 辅导员提交德育评估
export const moralEducationEvaluationSubmitApproval = p => POSTNEW('/studentv2/evaluation/apply/saveDyApply/TEACHER', p)

// 下载学生综合测评PDF
export const downloadEvaluationPDF = p => POSTNEW('/studentv2/evaluation/project/createPdf', p)

// 学院确认按钮
export const evaluationfaculytConfirm = p => POSTNEW('/studentv2/evaluation/planFaculty/confirmFaculty', p)

// 批量导出PDF
export const evaluationDownloadPdf = p => EXPORTNEW('/studentv2/evaluation/apply/batchDownloadPdf', p)

// 批量导出学生名单
export const evaluationDownloadStudent = p => EXPORTNEW('/studentv2/evaluation/apply/export', p)

// 修改学院计划状态
export const changeEvaluationFacultyPlanStatus = p => POSTNEW('/studentv2/evaluation/planFaculty/updateFacultyPlanStatus', p)

// 修改总体计划状态
export const changeEvaluationAllPlanStatus = p => POSTNEW('/studentv2/evaluation/plan/updatePlan', p)

// 获取代理人列表
export const getEvaluationAgentTableData = p => POSTNEW('/studentv2/evaluation/proxy/page', p)

// 批量删除代理人
export const evaluationDeleteAgentList = p => POSTNEW('/studentv2/evaluation/proxy/removeByIds', p)

//综测档案
//获取是当前哪个学年
export const checkCurrentSchoolYear = p => POSTNEW('/studentv2/evaluationApplyHkjInfo/findSchoolYear', p)

// 综合测评档案列表分页
export const evaluationArchiveListTableData = p => POSTNEW('/studentv2/evaluationApplyHkjInfo/page', p)

//获取综测档案 单条详情
export const queryEvaluationArchiveListInforDetail = p => POSTNEW('/studentv2/evaluationApplyHkjInfo/detail', p)

//导出
export const evaluationArchiveListExport = p => POSTNEW('/studentv2/evaluationApplyHkjInfo/export', p)

//--------------------------------

//----------------------计划页面---------------------
//获取计划列表数据
export const evaluationQueryPlanData = p => POSTNEW('/studentv2/evaluationHome/getPlanPage', p)
//切换 打卡/关闭 状态
export const evaluationUpdatePlanStatus = p => POSTNEW('/studentv2/evaluationHome/updatePlanStatus', p)


//---------------------设置权重分数页面---------------------
//获取权重配比
export const evaluationQuerySettingData = p => GETNEW('/studentv2/evaluationHome/getSettings/{id}', p)
//获取其他设置内容
export const evaluationQueryOtherSettingData = p => GETNEW('/studentv2/evaluationHome/getOtherSettings/{id}', p)
//提交
export const evaluationSubmitSettingData = p => POSTNEW('/studentv2/evaluationHome/settings', p)

//----------------------列表页-------------------------
//获取人数
export const evaluationQueryPersonNum = p => POSTNEW('/studentv2/evaluationHome/getContent', p)
//查询 学院、年级、班级
export const evaluationListData = p => POSTNEW('/studentv2/evaluationHome/getContentByGroup/', p)
//查询当前节点
export const evaluationCurrentStatus = p => POSTNEW('/studentv2/evaluationHome/getFacultyStatus', p)
//查询学生
export const evaluationListDataByStudent = p => POSTNEW('/studentv2/evaluationHome/getStudentList', p)
//查询导入内容
export const evaluationQueryImportInfor = p => POSTNEW('/studentv2/evaluationHome/getProjectList', p)
//上传
export const evaluationImport = p => POSTFormData('/studentv2/evaluationHome/import', p)
//获取获取学院是否导入情况状态
export const evaluationQueryImportStatus = p => POSTNEW('/studentv2/evaluationHome/getFacultyImportStatus', p)
//班主任获取 专业班级
export const evaluationQueryClassByTearcher = p => POSTNEW('/studentv2/evaluationHome/getTeacherTree', p)

//---------------------学生详情-----------------------------
//查询
export const evaluationQueryStudentDetail = p => POSTNEW('/studentv2/evaluationHome/getStudentDeatil', p)
//提交
export const evaluationSubmitStudentDetail = p => POSTNEW('/studentv2/evaluationHome/saveInfo', p)
//撤销
export const evaluationWithdrawApply = p => POSTNEW('/studentv2/evaluationHome/withdrawApply', p)

//---------------------管理评定小组------------------------------
//获取评定小组
export const evaluationGetStudentTeam = p => POSTNEW('/studentv2/evaluationHome/getStudentTeam', p)
//添加评定小组
export const evaluationAddStudentTeam = p => POSTNEW('/studentv2/evaluationHome/addStudentTeam', p)
//移出
export const evaluationRemoveStudentTeam = p => POSTNEW('/studentv2/evaluationHome/removeTeamById', p)
//获取当前班级所有学生 不包括评定小组
export const evaluationGetStudentNotInTeam = p => POSTNEW('/studentv2/evaluationHome/getStudentListNotInTeam', p)



// WEBPACK FOOTER //
// ./src/api/modules/evaluation.js